import moment from 'moment';
import { includes } from 'lodash';
import retry from '@blockcatio/tabby-library/lib/utilities/retry';
import createPollerMiddleware from '@blockcatio/tabby-library/lib/utilities/poller';

import { getLocalPaymentsToDiscard } from '../selectors/payments';
import {
  paymentsFetched,
  paymentFetchFailed,
  paymentEventsFetched,
  paymentEventsFetchFailed,
  paymentPending,
  paymentPendingFailed,
  paymentLocallyDiscarded,
  paymentLocallyDiscardFailed,
} from '../actions/payments';
import { APP_SHUTDOWN, PAYMENT_EVENTS_FETCHED, LATEST_BLOCK_NUMBER_UPDATED } from '../actionTypes';

export default ({ tabbyPay }) => (store) => {
  const { dispatch } = store;
  return createPollerMiddleware(store, {
    initialState: { lastBlock: 0 },

    frequency: 1500,

    checkStart: (action, nextState, prevState) =>
      nextState.account.address !== prevState.account.address,

    checkStop: action => action.type === APP_SHUTDOWN,

    checkRun: (myState, reduxState) =>
      reduxState.account.address && reduxState.app.latestBlockNumber,

    main: async (pollerState, reduxState) => {
      let { lastBlock } = pollerState;
      const { latestBlockNumber } = reduxState.app;

      // Use the toBlock from our payment fetch as the minimum.
      if (latestBlockNumber > lastBlock) {
        lastBlock = latestBlockNumber;
      }

      try {
        const events = await retry(() => tabbyPay.fetchEventsSince(lastBlock + 1));
        if (events.length) {
          dispatch(paymentEventsFetched(events));
          lastBlock = events.reduce(
            (maximum, event) => Math.max(maximum, event.blockNumber),
            lastBlock,
          );
        }
      } catch (error) {
        dispatch(paymentEventsFetchFailed(error));
      }

      return { lastBlock };
    },

    onAction: async (action) => {
      if (action.type === PAYMENT_EVENTS_FETCHED) {
        const address = store.getState().account.address.toLowerCase();
        action.events.forEach((event) => {
          if (
            event.event === 'PaymentCreated' &&
            includes(
              [
                event.returnValues.sender.toLowerCase(),
                event.returnValues.destination.toLowerCase(),
              ],
              address,
            )
          ) {
            const sendType =
              event.returnValues.sender.toLowerCase() === address ? 'outgoing' : 'incoming';
            try {
              store.dispatch(paymentPending(event, sendType, moment().unix()));
            } catch (error) {
              store.dispatch(paymentPendingFailed(error));
            }
          }
        });
      }

      // Fetch all payments only when we get the latest block number.
      if (action.type === LATEST_BLOCK_NUMBER_UPDATED) {
        const {
          account: { address },
          app: { latestBlockNumber },
        } = store.getState();
        if (address) {
          try {
            const payments = await retry(() => tabbyPay.fetchPayments(address, latestBlockNumber));
            dispatch(paymentsFetched(payments));

            getLocalPaymentsToDiscard(store.getState()).forEach((payment) => {
              try {
                store.dispatch(paymentLocallyDiscarded(payment));
              } catch (error) {
                store.dispatch(paymentLocallyDiscardFailed(error));
              }
            });
          } catch (error) {
            dispatch(paymentFetchFailed(error));
          }
        }
      }
    },
  });
};



// WEBPACK FOOTER //
// ./src/middleware/pollPayments.js